import React, { Component, MouseEvent } from "react";
import { connect } from "react-redux";
import messages from "./Projects.messages";
import { Card, Table } from "reactstrap";
import { ThreeDots } from "react-bootstrap-icons";
import moment from "moment";
import https from "https";

import * as actions from "../../../redux/projects/actions";
import { getProjects, isFetchingProjects } from "../../../redux/projects";
import { getActiveTab } from "../../../redux/app";
import { getUser, isLoggedIn, getPlanName } from "../../../redux/user";
import { createTimelineEvent } from "../../../redux/timeline";

import type ProjectCollection from "../../../models/ProjectCollection";
import type TimelineEventCollection from "../../../models/TimelineEventCollection";
import type Project from "../../../models/Project";
import type User from "../../../models/User";

import ProjectModal from "../components/modals/project-modal/ProjectModal";
import ProjectModalDelete from "../components/modals/project-modal-delete/ProjectModalDelete";
import ProjectImage from "../components/project-image/ProjectImage";
import SubscribeModal from "../components/modals/subscribe-modal/SubscribeModal";
import OptsDropdown from "./OptsDropdown";
import {
  accountExpired,
  canAddProject,
  findPlanName,
  signedUpMoreThan7DaysAgo,
  getAuthToken,
  getOneSignalInfo,
  isMobile,
  setOneSignalInfoResponse,
} from "../../../helpers/Utils";

type StateProps = {
  activeTab: TabKey,
  isFetchingProjects: boolean,
  isLoggedIn: boolean,
  projects: ProjectCollection,
  selectedTimelineEvents: TimelineEventCollection,
};

type OwnProps = {
  user: User,
  onPressProject: () => void,
};

type State = {
  showNewProjectModal: boolean,
  showSubscribeModal: boolean,
  showUpdateProjectModal: boolean,
  showDeleteProjectModal: boolean,
  showDuplicateProjectModal: boolean,
  selectedProject: Project,
};

class Projects extends Component {
  props: Props;
  state: State = {
    showNewProjectModal: false,
    showSubscribeModal: false,
    showUpdateProjectModal: false,
    showDeleteProjectModal: false,
    showDuplicateProjectModal: false,
    selectedProject: null,
  };
  loadProjectsPromise: ?Promise<void>;
  setActiveProjectPromise: ?Promise<void>;
  clearActiveProjectPromise: ?Promise<void>;

  constructor(props: Props) {
    super(props);
  }

  componentDidMount() {
    if (this.props.isLoggedIn) {
      this.loadProjectsPromise = Promise.resolve(this.props.loadProjects());
      this.loadOneSignalInfo();
    }
  }

  getSortedProjects(): Project[] {
    const sortedProjects = this.props.projects.sortByDate();
    return sortedProjects.toArray();
  }

  loadOneSignalInfo(): void {
    const oneSignalInfo =
      getOneSignalInfo() && getOneSignalInfo().oneSignalInfo;
    // console.log(
    //   "loadonesignalinfo",
    //   this.props.user.email,
    //   oneSignalInfo,
    //   oneSignalInfo && oneSignalInfo.oneSignalSubscribed,
    //   window.OneSignal,
    //   window.OneSignal && window.OneSignal.initialized,
    //   oneSignalInfo && oneSignalInfo.oneSignalPushToken
    // ); // DEBUG

    // STARTHERE I think this if statement is wrong. I think oneSignalSubscribed
    // will be false on first run.
    // Also it looks like the push notiication certificate has expired (see
    // onesignal Platforms page).

    if (
      !oneSignalInfo ||
      oneSignalInfo.oneSignalSubscribed ||
      !(window.OneSignal && window.OneSignal.initialized)
    )
      return;

    // Copied from https://documentation.onesignal.com/reference/add-a-device
    const data = oneSignalInfo
      ? {
          app_id: process.env.REACT_APP_ONESIGNAL_API_KEY,
          external_id: this.props.user.email,
          device_type: 0, // iOS
          identifier: oneSignalInfo.oneSignalPushToken,
        }
      : {};
    // console.log("onesignal data", data); // DEBUG

    const headers = {
      "Content-Type": "application/json; charset=utf-8",
    };

    const options = {
      host: "onesignal.com",
      port: 443,
      path: "/api/v1/players",
      method: "POST",
      headers: headers,
    };

    const req = https.request(options, (res) => {
      res.on("data", (data) => {
        console.log("Response:");
        console.log(JSON.parse(data));
        setOneSignalInfoResponse(JSON.parse(data));
      });
    });

    req.on("error", (e) => {
      console.log("ERROR:");
      console.log(e);
    });

    req.write(JSON.stringify(data));
    req.end();
  }

  handleEditClick = (event: MouseEvent, project: Project) => {
    event.stopPropagation();
    this.setState({ showUpdateProjectModal: true, selectedProject: project });
  };
  handleDeleteClick = async (event: MouseEvent, project: Project) => {
    event.stopPropagation();
    this.setState({ showDeleteProjectModal: true, selectedProject: project });
  };
  handleDuplicateClick = (event: MouseEvent, project: Project) => {
    event.stopPropagation();
    this.setState({
      showDuplicateProjectModal: true,
      selectedProject: project,
    });
    this.handleSelectProject(project, true);
  };

  handleCloseModals = () => {
    this.setState({
      showNewProjectModal: false,
      showSubscribeModal: false,
      showUpdateProjectModal: false,
      showDeleteProjectModal: false,
      showDuplicateProjectModal: false,
      selectedProject: null,
    });
  };

  // NOTE: should not duplicate photo or tasks
  handleDuplicateProject = async (params) => {
    if (canAddProject(this.props.user, this.props.projects)) {
      const sourceEvents = params.timelineEvents;
      const sourceProject = this.state.selectedProject;

      const projectId = await this.props.createProject({
        name: sourceProject.name + " copy",
        date: params.date || sourceProject.date,
        // In case we want to enable duplicating photo
        // photoURL: sourceProject.photoURL || "",
        photoURL: "",
        collaboratorEmail: sourceProject.collaboratorEmail,
        timezone: sourceProject.timezone,
      });

      // duplicating events
      if (projectId) {
        sourceEvents &&
          sourceEvents.data.map((event) => {
            // Calculate the date and pass it in in the format "2019-07-03T02:00:00-06:00"
            // for consistency with what the datepicker returns.
            const oldDateTime = event.timezonelessDateTime();
            let newDate = moment
              .utc(params.date, "MM/DD/YYYY")
              .format("YYYY-MM-DD");
            let oldTime = moment.utc(oldDateTime).format("HH:mm:ss");
            let newDateTime = moment.utc(`${newDate}T${oldTime}Z`).format();

            this.props.createTimelineEvent({
              name: event.name,
              dateTime: newDateTime || event.timezonlessDateTime(),
              location: event.location,
              details: event.details,
              projectId: projectId,
            });
          });
      }

      // reload afterward
      window.location.reload();
    }
  };

  onProjectDelete = () => {
    this.handleCloseModals();
    window.location.href = "/projects";
  };

  handleSelectProject = (project: Project, preventNavigation: boolean) => {
    this.setActiveProjectPromise = Promise.resolve(
      this.selectProject(project, preventNavigation)
    );
  };

  async selectProject(project: Project, preventNavigation: boolean) {
    await this.props.setActiveProject(project);
    if (!preventNavigation) {
      this.props.onPressProject();
    }
  }

  handleAddProject = () => {
    if (canAddProject(this.props.user, this.props.projects)) {
      this.clearActiveProjectPromise = Promise.resolve(
        this.clearProjectAndAdd()
      );
    } else {
      this.openSubscribeModal();
    }
  };

  async clearProjectAndAdd() {
    await this.props.clearActiveProject();
    this.openNewProjectModal();
  }

  openNewProjectModal() {
    this.setState({
      showNewProjectModal: true,
    });
  }

  closeNewProjectModal() {
    this.setState({
      showNewProjectModal: false,
    });
  }

  openSubscribeModal() {
    this.setState({
      showSubscribeModal: true,
    });
  }

  closeSubscribeModal() {
    this.setState({
      showSubscribeModal: false,
    });
  }

  //TODO use the one in agenda/collaborators/Collaborators instead of reinventing the wheel
  renderPlanName() {
    var planName = "Basic";

    //TODO subscription
    if (this.props.user.planId) {
      planName = getPlanName(this.props.user.planId);
    } else if (this.props.user.isPremium) {
      planName = "Premier - Trial";
    }

    return planName;
  }

  // prettier-ignore
  render() {
    // // Make it automatically reregister the notification token
    // const needsToReloginAndRefreshNotificationToken = () => {
    //   if (isMobile() && this.props.user) {
    //     console.log(1);
    //     const devicesAttr = this.props.user && this.props.user.devices;
    //     console.log(1.1, devicesAttr, this.props.user);
    //     if (!devicesAttr) return true;

    //     console.log(2, devicesAttr);
    //     let devicesObj = null;
    //     let devicesList = null;
    //     try {
    //       devicesObj = JSON.parse(devicesAttr);
    //     } catch (err) {
    //       return true;
    //     }
    //     devicesList = Object.values(devicesObj);

    //     console.log(3, devicesList);
    //     const thisDeviceCloseToExpiry = devicesList.find(
    //       (device) =>
    //         device.deviceId ===
    //           getOneSignalInfo().oneSignalInfo.oneSignalUserId &&
    //         moment(device.expires).subtract(7, "days").unix() < moment().unix()
    //     );
    //     console.log(4, thisDeviceCloseToExpiry);
    //     if (thisDeviceCloseToExpiry) return true;
    //   }
    //   console.log(5);
    //   return false;
    // };

    // if (needsToReloginAndRefreshNotificationToken()) this.props.handleLogout()

    return (
      <div>
        {!this.props.isFetchingProjects && this.renderTable()}
        {!!this.state.showNewProjectModal && this.renderNewProjectModal()}
        {!!this.state.showSubscribeModal && this.renderSubscribeModal()}

        {!!this.state.showUpdateProjectModal && this.renderUpdateProjectModal()}
        {!!this.state.showDeleteProjectModal && this.renderDeleteProjectModal()}
        {!!this.state.showDuplicateProjectModal && this.renderDuplicateProjectModal()}
      </div>
    );
  }

  renderTable() {
    return (
      <div>
        {this.props.projects.length ? (
          <Table hover className="mb-0 projects-table">
            <tbody>{this.getSortedProjects().map(this.renderProjectRow)}</tbody>
          </Table>
        ) : (
          <div style={{ marginTop: 20 }}>{messages.blankMessage}</div>
        )}
      </div>
    );
  }

  renderProjectRow = (project: Project) => {
    const imageHeight = window.innerWidth > 500 ? 120 : 80;
    const imageWidth = imageHeight * 1.5;

    return (
      <tr
        key={project.id}
        className="project-row"
        onClick={() => this.handleSelectProject(project)}
      >
        <td className="project-cell">
          <div className="picture-cell">
            <ProjectImage
              url={project.photoURL}
              width={imageWidth}
              height={imageHeight}
            />
          </div>
          <div
            className="details"
            style={{ width: `calc(100% - ${imageWidth}px` }}
          >
            <div className="details-content">
              <div className="name">{project.name}</div>
              <div className="date">Date: {project.date}</div>
            </div>
            <div className="menu-cell">
              <div className="menu-container">
                {this.renderThreeDotsDropdown(project)}
              </div>
            </div>
          </div>
        </td>
      </tr>
    );
  };

  renderThreeDotsDropdown = (project: Project) => (
    <OptsDropdown
      direction="left"
      project={project}
      facade={<ThreeDots size="20" />}
      handleEditClick={(event: MouseEvent) =>
        this.handleEditClick(event, project)
      }
      handleDeleteClick={(event: MouseEvent) =>
        this.handleDeleteClick(event, project)
      }
      handleDuplicateClick={(event: MouseEvent) =>
        this.handleDuplicateClick(event, project)
      }
      canAddProject={canAddProject(this.props.user, this.props.projects)}
      accountExpired={accountExpired(this.props.user)}
      isOwner={this.props.user && project && project.role === "owner"}
    />
  );

  renderNewProjectModal = () => {
    return (
      <ProjectModal
        onModalClose={() => this.closeNewProjectModal()}
        user={this.props.user}
      />
    );
  };

  renderSubscribeModal = () => {
    const alertMessage = this.renderAlertMessage();
    return (
      <SubscribeModal
        user={this.props.user}
        onModalClose={() => this.closeSubscribeModal()}
        alertMessage={alertMessage}
      ></SubscribeModal>
    );
  };

  //TODO is this even used?
  renderAlertMessage() {
    const planName = findPlanName(this.props.user);

    if (isMobile()) return messages.mobileMessage;
    switch (planName) {
      case "Single":
        return messages.singleMessage;
      case "Basic":
        return messages.basicMessage;
      case "Standard":
        return messages.standardMessage;
      case "Premier":
        return messages.premierMessage;
    }
  }

  renderUpdateProjectModal = () => (
    <ProjectModal
      onModalClose={this.handleCloseModals}
      user={this.props.user}
      project={this.state.selectedProject}
    />
  );

  renderDeleteProjectModal = () => {
    return (
      <ProjectModalDelete
        onModalClose={() => this.handleCloseModals()}
        onDelete={() => this.onProjectDelete()}
        user={this.props.user}
        project={this.state.selectedProject}
      />
    );
  };

  renderDuplicateProjectModal = () => {
    return (
      <ProjectModal
        duplicate
        handleDuplicateProject={this.handleDuplicateProject}
        user={this.props.user}
        project={this.state.selectedProject}
        onModalClose={() => this.handleCloseModals()}
      />
    );
  };
}

const isNarrowScreen = () => {
  if (window.innerWidth > 600) return false;
  return true;
};

const mapStateToProps = (state) => {
  return {
    user: getUser(state),
    activeTab: getActiveTab(state),
    isFetchingProjects: isFetchingProjects(state),
    isLoggedIn: isLoggedIn(state),
    projects: getProjects(state),
  };
};

const mapActionsToProps = { ...actions, createTimelineEvent };

export default connect(mapStateToProps, mapActionsToProps)(Projects);



// WEBPACK FOOTER //
// ./src/views/user/projects/Projects.js